import { useMemo } from 'react';
import { useGameStore } from '../state/game-store.js';
import { useUiStore } from '../state/ui-store.js';
import { MoveTicker } from './MoveTicker.js';

/**
 * Composes the top (opponent) and bottom (player) move ticker strips.
 * Renders ONLY when the sidebar is collapsed — when expanded, the in-sidebar
 * move list carries the same info, and rendering both would duplicate the
 * signal without adding clarity.
 */
export function MoveTickers() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const adapter = useGameStore((s) => s.adapter);
  const pos = useGameStore((s) => s.pos);

  // Memoize — adapter.history() returns a fresh array each call; selecting
  // it directly would give useSyncExternalStore an unstable snapshot.
  const moves = useMemo(() => adapter.history(pos), [adapter, pos]);

  if (!collapsed) return null;

  return (
    <div className="flex flex-col gap-1.5">
      <MoveTicker side="b" moves={moves} anchor="top" />
      <MoveTicker side="w" moves={moves} anchor="bottom" />
    </div>
  );
}
